import React from 'react';
import { Flex, Button } from '@chakra-ui/react';

export interface WizardNavigationProps {
  onBack?: () => void;
  onNext?: () => void;
  onSkip?: () => void;
  backLabel?: string;
  nextLabel?: string;
  skipLabel?: string;
  isFirstStep?: boolean;
  isLastStep?: boolean;
  showSkip?: boolean;
  isNextDisabled?: boolean;
  isLoading?: boolean;
}

/**
 * WizardNavigation - Back/Next/Skip buttons for wizard
 */
export function WizardNavigation({
  onBack,
  onNext,
  onSkip,
  backLabel = 'Back',
  nextLabel = 'Next',
  skipLabel = 'Skip',
  isFirstStep = false,
  isLastStep = false,
  showSkip = false,
  isNextDisabled = false,
  isLoading = false,
}: WizardNavigationProps) {
  return (
    <Flex justify="space-between" align="center" px={4} py={4} gap={4}>
      {!isFirstStep ? (
        <Button
          variant="outline"
          h="48px"
          px={6}
          borderRadius="12px"
          fontWeight="600"
          borderColor="gray.200"
          color="gray.800"
          onClick={onBack}
          isDisabled={isLoading}
          _hover={{ bg: 'gray.50' }}
        >
          {backLabel}
        </Button>
      ) : (
        <Flex flex={1} />
      )}

      {showSkip && onSkip && (
        <Button
          variant="ghost"
          h="48px"
          px={6}
          borderRadius="12px"
          fontWeight="600"
          color="gray.500"
          onClick={onSkip}
          isDisabled={isLoading}
          _hover={{ color: 'gray.800' }}
        >
          {skipLabel}
        </Button>
      )}

      <Button
        h="48px"
        px={6}
        borderRadius="12px"
        fontWeight="600"
        bg="brand.500"
        color="white"
        onClick={onNext}
        isDisabled={isNextDisabled || isLoading}
        opacity={isNextDisabled ? 0.5 : 1}
        _hover={{ bg: 'brand.600' }}
        _active={{ bg: 'brand.700' }}
      >
        {isLoading ? 'Loading...' : isLastStep ? 'Complete' : nextLabel}
      </Button>
    </Flex>
  );
}

export default WizardNavigation;
